module.exports = __webpack_public_path__ + "f845bd16aa0f60d825543d688af4d4a8.png";